import { Auth } from "@/services/firebase/auth"
import { DB } from "@/services/firebase/db"
import Project from "@/types/project/project"
import firebase from "firebase/compat"

export class ProjectService {
  getAllProjects () {
    return DB.collection('projects')
      .where('userId', '==', Auth.currentUser?.uid)
      .where('project.active', '==', true)
      .get()
      .then((projectQuery) => {
        return projectQuery.docs.map((doc) => {
          if (doc.exists) {
            return {
              ...doc.data().project,
              id: doc.id,
              userId: doc.data().userId
            }
          }
        })
      }).then((projects) => {
        return projects
      })
  }

  createProject (projectData: Project) {
    const storableProjectData = {
      name: projectData.name,
      owner: projectData.owner,
      active: projectData.active,
      billingType: projectData.billingType,
      salary: projectData.salary,
      description: projectData.description
    }
    return DB.collection('projects').add({
      createdAt: new Date(),
      project: (Object.assign({}, storableProjectData)),
      userId: Auth.currentUser?.uid
    }).then((docRef) => {
      return docRef.id
    })
  }

  deleteProject (projectId: string) {
    return DB.collection('projects').doc(projectId).delete()
  }

  getUserIdFromProject (projectId: string) {
    return DB.collection('projects')
      .doc(projectId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          return doc.data()?.userId
        }
      })
  }

  getUserIdsFromProjects (projectIds: (string | null)[]) {
    return DB.collection('projects')
      .where(firebase.firestore.FieldPath.documentId(), 'in', projectIds)
      .get()
      .then((query) => {
        return query.docs.map((project) => {
          return project.data().userId
        })
      })
  }

  getProject (projectId: string) : Promise<Project | undefined> {
    return DB.collection('projects')
      .doc(projectId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          return new Project({
            ...doc.data()!.project,
            id: doc.id
          })
        }
      })
  }

  updateProject (projectId: string, projectData: Project) {
    const storableProjectData = {
      name: projectData.name,
      billingType: projectData.billingType,
      salary: projectData.salary,
      description: projectData.description
    }
    return DB.collection('projects').doc(projectId).set({
      project: (Object.assign({}, storableProjectData))
    }, { merge: true })
  }

  getProjectsByIds (projectIds: (string | null)[]) {
    return DB.collection('projects')
      .where(firebase.firestore.FieldPath.documentId(), 'in', projectIds)
      .get()
      .then((projectQuery) => {
        return projectQuery.docs.map((doc) => {
          if (doc.exists) {
            return {
              ...doc.data().project,
              id: doc.id,
              userId: doc.data().userId
            }
          }
        })
      }).then((projects) => {
        return projects as Project[]
      })
  }

  setProjectState (projectId: string, state: boolean) {
    return DB.collection('projects').doc(projectId)
      .set({
        project: {
          active: state
        }
      }, { merge: true })
  }

  setProjectOwner (projectId: string, owner: boolean) {
    return DB.collection('projects').doc(projectId)
      .set({
        project: {
          owner: owner
        }
      }, { merge: true })
  }
}
